module.exports = __webpack_public_path__ + "img/8.4715ec7b.png";